import React, { useState, useContext } from "react"

import { Row, Col } from "react-bootstrap"

import { SOCIAL_FORM_SUBMIT } from "../candidate-profile/actions/socialAction"
import { COMPANY_SOCIAL_FORM_SUBMIT } from "../company-profile/actions/socialAction"

import Warning from "../../images/icons/wdn-warning.png"

import InputTextBox from "../input/input-text-box"
import TagInput from "../input/tag-input"
import { GlobalAuthContext } from "../../context/authContext"
import { removeAlreadySelectedSocialFromSelect } from "../../utils/removeAlreadySavedSocialFromSelect"

const SocialInputForm = props => {
  const {
    setSocialFormData,
    socialFormData,
    setAddSocial,
    social,
    setSocial,
  } = props

  const [error, setError] = useState({})

  const handleSocialSiteChange = value => {
    setSocialFormData({ ...socialFormData, site: value })
  }

  const handleUsernameChange = value => {
    setSocialFormData({ ...socialFormData, url: value })
  }

  const handleOnFocus = () => {
    setError({})
  }

  const [isLoading, setIsLoading] = useState(false)
  const { state } = useContext(GlobalAuthContext)

  const handleSocialFormSubmit = e => {
    setIsLoading(true)
    e.preventDefault()
    if (
      socialFormData?.site?.name &&
      socialFormData?.url &&
      state?.user?.role === 2
    ) {
      SOCIAL_FORM_SUBMIT(
        socialFormData,
        setError,
        setAddSocial,
        setIsLoading,
        social,
        setSocial
      )
    } else if (
      socialFormData?.site?.name &&
      socialFormData?.url &&
      state?.user?.role === 3
    ) {
      COMPANY_SOCIAL_FORM_SUBMIT(
        socialFormData,
        setError,
        setAddSocial,
        setIsLoading,
        social,
        setSocial
      )
    } else {
      setError({ message: "Social Site or link is missing." })
      setIsLoading(false)
    }
  }

  return (
    <>
      <h1>Add Social</h1>
      <form onSubmit={handleSocialFormSubmit}>
        <Row>
          <Col>
            {props?.disabled ? (
              <div
                className={error?.message ? "form-group error" : "form-group"}
              >
                <label htmlFor="social">Social Site</label>
                <div
                  className={
                    (error?.message ? "error" : "") +
                    " form-control edit-view pt-2"
                  }
                >
                  {socialFormData?.site?.name}
                </div>
              </div>
            ) : (
              <TagInput
                name="social"
                styles={
                  error?.message ? ` outline-faded error` : ` outline-faded`
                }
                options={removeAlreadySelectedSocialFromSelect(
                  state?.config?.social,
                  social
                )}
                useOnChange={handleSocialSiteChange}
                value={socialFormData?.site}
                onFocus={handleOnFocus}
                label="Social Site"
                placeholder={"Type and Select..."}
                closeMenuOnSelect
                isClearable
                disabled={props.disabled}
              />
            )}
          </Col>
        </Row>
        <Row>
          <Col>
            <InputTextBox
              onFocus={handleOnFocus}
              name="Url"
              onChange={handleUsernameChange}
              placeholder="https://facebook.com/username"
              label="Url"
              value={socialFormData?.url}
              class={error?.message && "error"}
            />
          </Col>
          <Col lg="12">
            {error &&
              Object.keys(error).map((err, index) => (
                <div
                  key={index}
                  className="alert-block mb-4 d-flex align-items-center"
                >
                  <img src={Warning} className="mr-3" alt="wdn-warning" />
                  {error[err]}
                </div>
              ))}
          </Col>
        </Row>

        <Row>
          <Col>
            <button
              type="submit"
              className="btn w-100 btn-custom rounded primary"
              disabled={isLoading}
            >
              {isLoading ? "Processing" : "Save"}
            </button>
          </Col>
        </Row>
      </form>
    </>
  )
}

export default SocialInputForm
